import React from 'react'
import Link from 'gatsby-link'
import {
  Button,
  Form,
  Divider,
  Segment,
  Breadcrumb,
  Icon,
} from 'semantic-ui-react'
import Helmet from 'react-helmet'

const SuggestPage = () => (
  <div style={{ maxWidth: 1260, margin: '0 auto' }}>
    <Helmet>
      <title>Suggest a growth tool | Find Growth Tools</title>
    </Helmet>
    <Segment basic>
      <Breadcrumb>
        <Breadcrumb.Section>
          <Link to="/" style={{ color: '#dcddde' }}>
            <Icon name="angle left" />Home
          </Link>
        </Breadcrumb.Section>
      </Breadcrumb>
    </Segment>
    <h1
      style={{
        fontSize: '3.25rem',
        color: '#fff',
      }}
    >
      Suggest a tool
    </h1>
    <br />
    <div style={{ maxWidth: 960, margin: '0 auto', minHeight:'400px' }}>
      <p style={{ fontSize: '1.25em', color: '#fff', textAlign: 'center' }}>
        Know a great growth-related product that isn't on the site? Make a suggestion!
      </p>
      <br/> 
<Segment basic style={{textAlign: 'center'}}>
  <Button primary  size="huge" href="https://stirred.typeform.com/to/opaKD4" target="_blank"><Icon name="external alternate"/> Suggest a tool</Button>
</Segment>
<br/>
      {/* <Segment>
        <div>
          <Divider hidden />
          <Form
            name="suggestToolForm"
            // netlify-honeypot="bot-field"
            action="/thanks"
            // netlify
            size="medium"
            method="post"
            data-netlify="true"
            data-netlify-honeypot="bot-field"
          >
            <Form.Input
              fluid
              type="text"
              label="Product Name"
              placeholder="Product Name"
              required="true"
              name="productName"
            />
            <Form.Input
              type="text"
              required="true"
              label="Website"
              placeholder="Website"
              name="website"
            />
            <Form.TextArea
              label="Comments"
              placeholder="Any additional comments"
              name="comments"
            />
            <Form.Group>
              <Form.Field>
                <Form.Input
                  type="email"
                  required="true"
                  label="Your email"
                  placeholder="Your Email"
                  name="email"
                />
              </Form.Field>
            </Form.Group>
            <Button primary type="submit">
              Send suggestion
            </Button>

            <p
              style={{
                display: 'none',
              }}
            >
              <input name="bot-field" />
            </p>
          </Form>
        </div>
      </Segment> */}
    </div>
  </div>
)

export default SuggestPage



// WEBPACK FOOTER //
// ./src/pages/suggest.js